import { deviceDetector } from "utils";

import { Track } from "@/src/lib/tracking";

/** `inv_landing_view` 事件名（fe-spec §3.9.1） */
export const INVITE_LANDING_VIEW_EVENT = "inv_landing_view";

/** `inv_legacy_link_open` 事件名（PRD S2.10：旧 Missions 邀请链接 `/task/invite/<code>`） */
export const INVITE_LEGACY_LINK_OPEN_EVENT = "inv_legacy_link_open";

export type InvitePlatform = "ios" | "android" | "pc" | "mobile_web";

/** 邀请相关埋点的 `platform` 参数（fe-spec §3.9.1）：App 壳 ios / android，浏览器按设备 mobile_web / pc */
export function resolveInvitePlatform(): InvitePlatform {
  if (deviceDetector.isIOSApp()) {
    return "ios";
  }
  if (deviceDetector.isAndroidApp()) {
    return "android";
  }
  return deviceDetector.isMobile() ? "mobile_web" : "pc";
}

/**
 * 被邀请人带链接码落地（Web 端）：未登录进起始页 / 登录页为 `new`，已登录被带回首页为 `existing`。
 * 无 DOM 宿主（判定发生在挂载期 / 抓码 effect 里），故程序化上报；Web 不带 `app_installed`。
 */
export function trackInviteLanding(userState: "new" | "existing"): void {
  Track.view(INVITE_LANDING_VIEW_EVENT, {
    platform: resolveInvitePlatform(),
    user_state: userState,
  });
}

/**
 * 打开旧 Missions 邀请链接（PRD S2.10）：链接码有确定校验结论后上报一次，
 * `matched` = 能否匹配到邀请人（后端判 valid）。429 / 网络失败等判不了的情况不报，等确定结论。
 */
export function trackLegacyInviteLinkOpen(matched: boolean): void {
  Track.event(INVITE_LEGACY_LINK_OPEN_EVENT, { matched: String(matched) });
}
